module.exports = __webpack_public_path__ + "DINNextLTPro-LightCondensed.woff?aaf04636ea0b62b95ce2e01a715daf92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightCondensed.woff
// module id = 1434
// module chunks = 0